import { ExpandedState } from "@tanstack/react-table";
import { useState } from "react";

export default () => {
	const [expanded, setExpanded] = useState<ExpandedState>({});

	return { expanded, setExpanded };
};
